// extracted by mini-css-extract-plugin
export default {"faqMain":"FaqMain_faqMain__wSjoE","faqListWrap":"FaqMain_faqListWrap__mPZwj","csInner":"FaqMain_csInner__DvOqO"};